<template>
  <div id="parklist-actions">
    <div class="router" >
      <router-view />
    </div>

    <FilterSection :actions="parks" :filters="filters" :page="page" />
  </div>
</template>

<script>
import FilterSection from "@/components/FilterSection.vue";

export default {
  props: {
    parks: Array,
    filters: Object,
  },
  data() {
    return {
      page: 1
    }
  },
  computed: {
  },
  components: {
    FilterSection,
  },
  watch: {
    $route(to) {
      // console.log('to: ', to, 'from: ', from)
      let params = to.params

      this.page = params.page || 1
    }
  },
};
</script>

<style lang="scss">
  #mainColMain .viewTabs .tabsContainer .tab.tabsWrapper .content .tabContent{
    border:none
  }

  nav.pagination{
    display: none;
  }


@media (min-width: 992px) {
    .topicSidebar {
        width: 33.33333333%;
        float: left;
        padding: 10px;
        max-width: 300px;
        margin-right: 0px;
        background: url(//www.seattle.gov/images/2015_img/PageBackgrounds/portalListWrapperBG960.png);
    }

    .topics {
      width: 66.6%;
      float: left;
    }

    #topicFilterContainer label, #additionalFiltersWrap label {
      font-size: 14px;
      font-weight: bold;
      line-height: 16px;
      width: 95%;
      height: 40px;
      margin-left: 25px;
    } 

    // #topicFilterContainer button {
    //   width: 45px;
    //   background: #003da5;
    //   color: #fff;
    //   border: 0;
    // }
}

@media (min-width: 992px) {
    .mobileOnly {
        display: none;
    }
}


</style>
